// api/bugs.ts — Client API du suivi des bugs (côté utilisateur).
//
// Déclaration, liste « ses bugs », fil de messages, captures (upload multipart).
// Le traitement éditeur est dans pmo-admin, hors de ce client.

import { req, upload } from './_internals.js';

export interface BugsListParams {
  state_code?: string;
  priority_code?: string;
  urgency_code?: string;
  include_resolved?: boolean;
  is_evolution?: boolean;
}

export const bugsApi = {
  getBugReferentials: () => req('GET', '/bugs/referentials'),
  getBugsBadge: () => req('GET', '/bugs/badge-count'),
  markBugSeen: (id: number | string) => req('POST', '/bugs/' + id + '/seen'),
  getBugs: (params?: BugsListParams) => {
    const qs = new URLSearchParams();
    if (params?.state_code) qs.set('state_code', params.state_code);
    if (params?.priority_code) qs.set('priority_code', params.priority_code);
    if (params?.urgency_code) qs.set('urgency_code', params.urgency_code);
    if (params?.include_resolved) qs.set('include_resolved', 'true');
    if (params?.is_evolution === true) qs.set('is_evolution', 'true');
    else if (params?.is_evolution === false) qs.set('is_evolution', 'false');
    const s = qs.toString();
    return req('GET', '/bugs' + (s ? '?' + s : ''));
  },
  getBug: (id: number | string) => req('GET', '/bugs/' + id),
  createBug: (d: unknown) => req('POST', '/bugs', d),
  updateBug: (id: number | string, d: unknown) => req('PATCH', '/bugs/' + id, d),
  deleteBug: (id: number | string) => req('DELETE', '/bugs/' + id),
  getBugStateHistory: (id: number | string) => req('GET', '/bugs/' + id + '/state-history'),
  getBugMessages: (id: number | string) => req('GET', '/bugs/' + id + '/messages'),
  addBugMessage: (id: number | string, body: string) =>
    req('POST', '/bugs/' + id + '/messages', { body }),
  updateBugMessage: (id: number | string, mid: number | string, body: string) =>
    req('PATCH', '/bugs/' + id + '/messages/' + mid, { body }),
  uploadBugImage: (id: number | string, file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return upload('/bugs/' + id + '/images', fd);
  },
  deleteBugImage: (id: number | string, iid: number | string) =>
    req('DELETE', '/bugs/' + id + '/images/' + iid),
};
